module.exports = __webpack_public_path__ + "img/data.41f7d78e.png";